import UsePostmortemInfo from "../../context/PostmortemContext";
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../auth/authConfig";
import { addCollaborators } from "./helpers/addCollaborators";
import { removeCollaborator } from "./helpers/removeCollaborator";
import { sendCollaborators } from "./helpers/sendCollaborators";
import { PostmortemServices } from "../../services/postmortemServices";
import { useLocation } from "react-router-dom";
import { useAddCollaboratorsInTeamsChatService } from "../../services/addCollaboratorsInTeamsChatService";
import { FetchUserProfileService } from "../../services/fetchUserProfileService";
import { formatProfiles } from "./helpers/formatProfiles";
import { postmortemApiEndpoint } from "../../config";
export const HandleCollaborators = (
  postmortemCollaborators,
  setPostmortemCollaborators
) => {
  // const [collaborator, setCollaborator] = useState("");
  const [collaborators, setCollaborators] = useState([]);
  const { postmortemTeamId } = UsePostmortemInfo();
  const [errMessage, setErrMessage] = useState(null);
  // const [postmortemTeamsChatData, setPostmortemTeamChatData] = useState("");
  const { instance, accounts } = useMsal();
  const { fetchPostmortemById } = PostmortemServices();
  const [fetchingProfiles, setFetchingProfiles] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const apiEndpoint = postmortemApiEndpoint;
  useEffect(() => {
    if (postmortemCollaborators) {
      setCollaborators([...postmortemCollaborators]);
    }
  }, [postmortemCollaborators]);

  // useEffect(() => {
  //   sendTeamsChatData();
  // }, [postmortemTeamsChatData]);
  const { addCollaboratorsinTeamsChatNew } =
    useAddCollaboratorsInTeamsChatService();

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  // const incidentID = params.get("incidentID");
  const postmortemID = params.get("postmortemID");
  const pageType = params.get("page_type");
  // const addCollaboratorsinTeamsChat = async (collaboratorEmail) => {
  //   fetchExecutions();
  // };
  const sendTeamsChatData = async (postmortemTeamsChatData, collaborator) => {
    if (postmortemTeamsChatData != "") {
      // const tokenResponse = await fetchToken(instance, loginRequest, accounts);
      // if (tokenResponse && tokenResponse.sessionExpired) {
      //   sessionStorage.clear();
      //   setSessionExpired(true);
      // }
      addCollaboratorsinTeamsChatNew(
        collaborator.toLowerCase(),
        postmortemTeamsChatData
      );
    }
  };
  const addCollaboratorsinTeamsChat = async (collaborator) => {
    if (postmortemID) {
      try {
        // setLoading(true);
        const data = await fetchPostmortemById(apiEndpoint, postmortemID + '?page_type=' + pageType);
        let postmortemData = data.postmortemData;


        // setPostmortemState(data.status);
        if (
          postmortemData && 
          postmortemData.teamsChatGroup != undefined && 
          postmortemData.teamsChatGroup.chatConversationId != undefined
        ) {
          sendTeamsChatData(
            postmortemData.teamsChatGroup.chatConversationId,
            collaborator
          );
        }
        // setPostmortemTeamChatData(data.teamsChatGroup.chatConversationId);
      } catch (error) {
        console.error(error);
        // setError(true);
      } finally {
        // setLoading(false);
      }
    }
  };
  // const handleCollaboratorChange = (event) => {
  //   setCollaborator(event.target.value);
  // };

  // function isMaerskEmail(inputValue) {
  //   // const emailRegex = /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
  //   var regex = /@maersk\.com$/;
  //   return regex.test(inputValue);
  //   // return emailRegex.test(inputValue);
  // }
  const { fetchUserProfile } = FetchUserProfileService();

  const getUserProfiles = async (event) => {
    if (event) {
      setFetchingProfiles(true);
      try {
        let profiles = await fetchUserProfile(event);
        const formattedProfiles = formatProfiles(profiles.value);
        setProfiles(formattedProfiles);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setFetchingProfiles(false);
      }
    }
  };

  const handleAddCollaborator = (event) => {
    setErrMessage("");
    if (event) {
      if (collaborators.find((collab) => collab.email === event.value)) {
        setErrMessage("Collaborator already added");
      } else {
        addCollaboratorsinTeamsChat(event.value);
        addCollaborators(
          setCollaborators,
          collaborators,
          event.value.toLowerCase(),
          setErrMessage,
          setPostmortemCollaborators,
          event.label || ""
        );
        sendCollaborators(
          [
            ...collaborators,
            { email: event.value.toLowerCase(), status: true },
          ],
          instance,
          loginRequest,
          accounts,
          postmortemTeamId
        );
      }
    }
  };

  const handleRemoveCollaborator = (collaborator) => {
    console.log('[REMOVE_COLLAB] Removing collaborator:', collaborator);
    console.log('[REMOVE_COLLAB] Current collaborators count:', collaborators?.length || 0);
    
    // Compute the filtered list FIRST
    const filteredCollaborators = collaborators.filter((collab) => collab.email !== collaborator);
    
    console.log('[REMOVE_COLLAB] Filtered collaborators count:', filteredCollaborators.length);
    console.log('[REMOVE_COLLAB] Filtered list:', filteredCollaborators.map(c => c.email));
    
    // Update UI state
    setCollaborators(filteredCollaborators);
    setPostmortemCollaborators(filteredCollaborators);
    
    // Send the filtered list to backend (not stale collaborators)
    console.log('[REMOVE_COLLAB] Sending to backend, count:', filteredCollaborators.length);
    sendCollaborators(
      filteredCollaborators,
      instance,
      loginRequest,
      accounts,
      postmortemTeamId
    );
  };

  return {
    handleAddCollaborator,
    handleRemoveCollaborator,
    collaborators,
    errMessage,
    fetchingProfiles,
    getUserProfiles,
    profiles,
  };
};
